/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Col, Row, Typography } from 'antd';

import { ColorField, TextField } from '@molecules';
import MediaField from '@organisms/MediaField';
import { Button } from '@atoms';

import Form from '../Form';

import { FORM_FIELD_IMAGE } from './constants';
import { IMAGE_SIZE } from '@api/media/constants';
import RichTextField from '@components/molecules/RichTextField';
import { TOOLBAR_ITEM } from '@components/atoms/RichTextEditor/constants';

const EXCLUDED_PARAMS = [
  TOOLBAR_ITEM.FORMAT_SELECT,
  TOOLBAR_ITEM.BACK_COLOR,
  TOOLBAR_ITEM.BLOCKQUOTE,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.NUMLIST,
  TOOLBAR_ITEM.BULLIST,
  TOOLBAR_ITEM.OUTDENT,
  TOOLBAR_ITEM.INDENT,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.TABLE,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.IMAGE,
  TOOLBAR_ITEM.MEDIA,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.FULLSCREEN,
  TOOLBAR_ITEM.CODE,
  TOOLBAR_ITEM.DELIMITER,
  TOOLBAR_ITEM.REMOVE_FORMAT,
  TOOLBAR_ITEM.CTA,
];

const ImageForm = ({ onSubmit, initialValues: initData, buttons, className, isUltimateDesign, isEdit }) => {
  const [form] = Form.useForm(FORM_FIELD_IMAGE);

  // Subtitle edited is use to avoid RichText issues
  const initialValues = React.useMemo(
    () =>
      form.deserialize(
        isEdit
          ? {
              ...initData,
              [FORM_FIELD_IMAGE.SUBTITLE_EDITED.name]: initData.subtitle,
            }
          : initData,
      ),
    [form, initData],
  );

  const handleFinish = React.useCallback(
    (value) => {
      if (isEdit) {
        value[FORM_FIELD_IMAGE.SUBTITLE.name] = value[FORM_FIELD_IMAGE.SUBTITLE_EDITED.name];
      }
      onSubmit(value, initData);
      form.resetFields();
    },
    [form, onSubmit, initData],
  );

  const imageSize = isUltimateDesign ? IMAGE_SIZE['350x326'] : IMAGE_SIZE['2000x1333'];

  return (
    <Form
      onSerializedFinish={handleFinish}
      initialValues={initialValues}
      className={className}
      layout="vertical"
      labelAlign="left"
      colon={false}
      form={form}
    >
      {buttons && <Typography.Text level={3}>Edit Slide</Typography.Text>}
      <Row>
        <Col flex="1">
          <Row>
            <Col flex="1">
              <MediaField {...FORM_FIELD_IMAGE.IMAGE} size={imageSize} />
              {isUltimateDesign && <TextField {...FORM_FIELD_IMAGE.TITLE} />}
              {isUltimateDesign && (
                <RichTextField
                  {...FORM_FIELD_IMAGE.SUBTITLE}
                  name={isEdit ? FORM_FIELD_IMAGE.SUBTITLE_EDITED.name : FORM_FIELD_IMAGE.SUBTITLE.name}
                  exclude={EXCLUDED_PARAMS}
                  showImageSelection={false}
                />
              )}
              {isUltimateDesign && <ColorField {...FORM_FIELD_IMAGE.BACKGROUND_COLOR} />}
            </Col>
          </Row>
          <Row>
            <Col flex="1" gutter={10}>
              {buttons ? (
                buttons({ onSubmit: form.submit })
              ) : (
                <Button type="customBlue" style={{ minWidth: 200 }} onClick={form.submit}>
                  ADD IMAGE
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default ImageForm;
